import {Breadcrumb, Text} from '@/components-v2'
import {PromotionProvider} from '@/context/Promotion/PromotionContext'
import {usePromotionDetail} from '@/hooks/usePromotionDetail'
import {PromotionActions} from '@/pages/Promotions/PromotionDetail/PromotionActions'
import {PromotionStatus} from '@/types/promotion'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useNavigate, useParams} from 'react-router-dom'
import {PromotionReview} from './steps/PromotionReview/PromotionReview'

export const PromotionDetailPage = () => {
  const {id} = useParams()
  const navigate = useNavigate()

  const {promotionData, isLoading, isError, error} = usePromotionDetail(id)

  const breadcrumbs = [
    {label: 'Promotions List', href: ROUTES.PROMOTIONS_LIST},
    {label: promotionData?.name || 'Promotion Detail', href: ROUTES.PROMOTION_DETAIL.replace(':id', id)},
  ]

  if (isLoading) {
    return (
      <div className="promotion-detail-loading">
        <div className="loading-spinner"></div>
        <p>Loading promotion details...</p>
      </div>
    )
  }

  if (isError) {
    return (
      <div className="promotion-detail-error">
        <h2>Error loading promotion details</h2>
        <p>{error?.message || 'Unknown error'}</p>
        <button className="ds-button ds-button--secondary" onClick={() => navigate(ROUTES.PROMOTIONS_LIST)}>
          Back to Promotions List
        </button>
      </div>
    )
  }

  if (!promotionData) {
    return (
      <div className="promotion-detail-not-found">
        <h2>No promotion found</h2>
        <p>The promotion with ID {id} could not be found.</p>
        <button className="ds-button ds-button--secondary" onClick={() => navigate(ROUTES.PROMOTIONS_LIST)}>
          Back to Promotions List
        </button>
      </div>
    )
  }

  const statusText = promotionData.status
    ? `${promotionData.status.charAt(0).toUpperCase() + promotionData.status.slice(1).toLowerCase()}`
    : 'Ongoing'

  const handleStepChange = step => {
    navigate(`/products/create-promotion/${promotionData?.id}`, {
      state: {
        promotionType: promotionData.promotionType,
        promotionId: promotionData?.id,
        step,
        isEditing: true,
      },
    })
  }

  const providerState = {
    state: {
      promotionType: promotionData.promotionType,
      promotionId: promotionData?.id,
      isEditing: true,
      isDuplicating: false,
    },
  }

  return (
    <PromotionProvider {...providerState}>
      <div className="promotion-detail-container">
        <Breadcrumb breadcrumbs={breadcrumbs} id="promotion-detail-breadcrumb" />

        <div className="mb-6 mt-6 flex items-center justify-between">
          <div className="flex flex-col">
            <Text headingLevel={5} className="mb-2">
              {promotionData.name}
            </Text>
            <Text size="body" variant="medium">
              {statusText} Promotion
            </Text>
          </div>
          <PromotionActions promotionData={promotionData} />
        </div>

        <PromotionReview
          data={promotionData}
          isDetailView={promotionData?.status?.toUpperCase() !== PromotionStatus.DRAFT}
          setCurrentStep={handleStepChange}
          showEditForAll={true}
        />
      </div>
    </PromotionProvider>
  )
}